module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/fb-circle-128.81dd33ad3097315a.png"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/fb-circle-128.81dd33ad3097315a.png",width: 128,height: 128}],
        src: "https://static.sniffspot.com/packs/img/fb-circle-128.81dd33ad3097315a.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/fb-circle-128.81dd33ad3097315a.png"},
        
        width: 128,
        height: 128
      }